import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { useQuery } from "@apollo/client/react";

import ActionModal from "../../components/modals/action-modal";
import { FETCH_USER } from "../../constants/graphql/queries";
import EditUserForm from "./EditUserForm";

export default function EditUserModal({ userId, onClose, onSuccess }) {
  const { data: { user } = {}, loading, refetch } = useQuery(FETCH_USER, {
    variables: { id: userId },
    fetchPolicy: "network-only",
    skip: !userId,
  });

  return (
    <ActionModal
      open
      id="editUserModal"
      title="Update User"
      maxWidth={600}
      onClose={onClose}
      disableTransition
    >
      <Box mt={1}>
        {loading || !user ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress color="primary" />
          </Box>
        ) : (
          <EditUserForm
            user={user}
            refetch={refetch}
            onSuccess={onSuccess}
            onClose={onClose}
          />
        )}
      </Box>
    </ActionModal>
  );
}
